module.exports = __webpack_public_path__ + "static/media/remove--gray.c488f3a8.svg";